import { FilterInput } from '@apeiron/common'
import { deserializeListData } from '@apeiron/temp'
import { ApolloError, useLazyQuery } from '@apollo/client'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { favoriteFilterSchema } from '@src/deserialize/yup/favoriteFilter'
import graphql from '@src/graphql/query/getFavoriteFilters'
import { FavoriteFilter } from '@src/types/favoriteFilter'
import { useCallback, useState } from 'react'

const useGetFavoriteFilter = <T extends FilterInput>(): Hook<T> => {
  const [query, { loading, error }] = useLazyQuery(graphql)

  const [data, setData] = useState<Response<T>>([])

  const fetch = useCallback(
    async (type: FavoriteType) => {
      const response = await query({ variables: { type } })

      const data = deserializeListData<FavoriteFilter<T> | any>(
        response,
        favoriteFilterSchema
      )

      setData(data)

      return data
    },
    [query]
  )

  return {
    fetch,
    data,
    loading,
    error
  }
}

type Response<T extends FilterInput> = FavoriteFilter<T>[]

type Hook<T extends FilterInput> = {
  fetch: (type: FavoriteType) => Promise<Response<T>>
  data: Response<T>
  loading: boolean
  error: ApolloError | undefined
}

export default useGetFavoriteFilter
